import { Model } from "@vuex-orm/core";
import Customer from "./Customer";
import User from "./User";

export default class Message extends Model {
  static entity = "messagesScheduled";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      customerId: this.number(0),
      messageData: this.attr(),
      isSent: this.boolean(false),
      scheduledAt: this.attr(),
      userId: this.number(0),

      customer: this.belongsTo(Customer, "customerId"),
      user: this.belongsTo(User, "userId")
    };
  }

  get messageType() {
    if (this.messageData && this.messageData.type) {
      return this.messageData.type;
    } else {
      return "sms";
    }
  }
  get messageBody() {
    if (this.messageData && this.messageData.message) {
      return this.messageData.message;
    } else {
      return "";
    }
  }
  get isInbound() {
    return false;
  }
  get isReviewRequest() {
    if (this.messageData && this.messageData.reviewRequest) {
      return this.messageData.reviewRequest;
    } else {
      return false;
    }
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      scheduledAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
